/* Le catalogue et les listes de prix sous un même toit : une liste se compose
   à partir des références, c'est donc là qu'elle se range — pas une entrée de
   plus dans le rail. */

import { useLocation, useNavigate } from "react-router-dom";
import { Onglets } from "@/ui/primitives";
import { Catalogue } from "./Catalogue";
import { Listes } from "@/features/listes/Listes";

type Onglet = "catalogue" | "listes";

export function Referentiel() {
  const lieu = useLocation();
  const navigue = useNavigate();
  const actif: Onglet = lieu.pathname.endsWith("/listes") ? "listes" : "catalogue";

  return (
    <>
      <div className="barre-onglets">
        <Onglets
          items={[
            { cle: "catalogue", nom: "Catalogue" },
            { cle: "listes", nom: "Listes de prix" },
          ]}
          actif={actif}
          onChange={(c) => navigue(c === "listes" ? "/catalogue/listes" : "/catalogue")}
        />
      </div>
      {actif === "catalogue" ? <Catalogue /> : <Listes />}
    </>
  );
}
